import styled from "styled-components";
import {grid} from "../../../utils/styled/_grid.style";
import {
	animations,
	colors,
	devices,
	fonts,
} from "../../../utils/styled/_variables.styled";
import {InfiosButton} from "../../Button/Button.style";
import {InfiosInputWrapper} from "../../FormComponents/Input/Input.style";
import {InfiosIconWrapper} from "../../Icon/Icon.style";
import {InfiosLearnMore} from "../../LearnMore/LearnMore.style";
import {InfiosLink} from "../../Link/Link.style";
import {InfiosBurgerWrapper} from "../HeaderBurger/HeaderBurger.style";

const animateItens = () => {
	let style = `&:first-child {
        animation-delay: 0s
    }`;

	for (let i = 2; i <= 15; i++) {
		style =
			style +
			`&:nth-child(${i}) {
            animation-delay: ${(i - 1) * 0.02}s
        }`;
	}

	return style;
};

export const InfiosHeaderMenuNavigation = styled.section`
	position: relative;
	justify-content: center;
	align-items: center;
	margin-left: 40px;

	.menuButtonWrapper,
	.menuButtonWithChildren,
	.stardard-link {
		margin-left: 30px;
	}

	.first-level {
		*:after {
			display: none !important;
		}
	}

	.tertiary,
	${InfiosLink} {
		position: relative;
		font-family: ${fonts.AeonikPro};
		padding: 0;

		&:hover {
			svg path {
				fill: ${colors.bluegray}
			}
		}

		${props => !props.isMobile && `
      white-space: break-spaces;
      text-align: left;
    `}
		&.p-regular {
			color: ${colors.bluegray};
			font-family: ${fonts.AeonikPro};
			font-size: 21.334px;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.427px;
			text-transform: none;
			line-height: 22px;
			transition: 0.3s ease all;

			&:hover {
				background: ${colors.limeGreen};
				font-size: 20px;

				svg {
					transform: translate(0, -50%);
				}

				&:after {
					display: none;
				}
			}

			${InfiosIconWrapper} {
				margin-right: 27px;

				@media ${devices.mobileAndTablet} {
					margin-right: 0;
				}

				svg {
					width: 12.644px;
					height: 12.817px;

					left: 0;
					margin-left: 3px;

					path {
						fill: ${colors.bluegray}
					}
				}
			}
		}

		& + .tertiary,
		& + ${InfiosLink} {
			margin-left: 30px;
		}

		&:after {
			content: "";
			position: absolute;
			display: none;
			bottom: 0;
			transform: translateY(19.5px);
			height: 3.5px;
			width: calc(100% + 8px);
			background-color: ${(props) => props.hoverColor ? props.hoverColor : (!(props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
			z-index: 10;
		}

		&:hover {
			color: ${colors.bluegray};

			&:after {
				display: flex;
			}
		}

		&:not(:hover) {
			color: ${(props) => ((props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.bluegray : colors.white)};
		}
	}

	ul {
		& + .tertiary,
		& + ${InfiosLink} {
			margin-left: 30px;
		}
	}

	${InfiosButton}, .stardard-link {
		order: unset;
		font-family: ${fonts.AeonikMono};
		text-transform: uppercase;
		font-size: 17px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: -0.34px;

		&.p-regular {
			font-family: ${fonts.AeonikPro};
		}
	}

	${InfiosBurgerWrapper} {
		&:hover {
			span {
				background-color: ${colors.blue};
			}
		}
	}

	@media ${devices.tablets} {
		${InfiosBurgerWrapper} {
			height: 20px;
			width: 23px;
		}
	}

	@media ${devices.mobile} {
		margin-left: 36px;

		${InfiosBurgerWrapper} {
			height: 20px;
			width: 23px;
		}
	}
`;

export const InfiosHeaderMenu = styled.nav`
	position: relative;
	display: flex;
	transition: ${animations.defaultTransition}, background 0s;

	.blur {
		position: fixed;
		width: 100vw;
		height: 20%;
		filter: blur(63px);
		backdrop-filter: blur(8px);
		z-index: 0;
		left: 0px;
		bottom: -1px;
	}

	&.mobile {
		position: fixed;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		left: 0;
		right: 0;
		background: ${colors.white};
		width: 100vw;
		height: calc(100vh - 64px);
		padding: 48px 20px;

		&.active {
			animation-name: appearMenu;
			animation-duration: 0.2s;
			animation-timing-function: ease-out;
			animation-fill-mode: backwards;
		}

		& > ${InfiosButton} {
			font-weight: 600 !important;
		}

		${InfiosLink},
		${InfiosButton} {
			justify-content: space-between;
			width: 100%;
			max-height: 100%;
			color: ${colors.bluegray};
			font-weight: 400;
			padding-right: 8px;
			overflow: hidden;
			border-radius: 0;
			transition: 0.3s all ease-out;
			padding: 8px 0;

			& + ${InfiosLink}, & + ${InfiosButton} {
				margin: 24px 0 0;
			}
		}

		${InfiosInputWrapper} {
			width: 100%;
			max-width: 100%;

			input {
				background-color: ${colors.gray1};
			}
		}

		${InfiosIconWrapper} {
			width: 27px;
			height: 20px;

			svg {
				width: 27px;
				height: 20px;

				path {
					fill: ${colors.infiosGray};
				}
			}

			@media ${devices.mobile} {
				width: 16px;
				height: 12px;

				svg {
					width: 16px;
					height: 12px;
				}
			}
		}

		${props => props.isMobile && `
			top: 69px;
		`}

		&:not(.active) {
			${props => props.isMobile && `
				display: none;
			`}
		}
	}

	.menu-active {
		&:after {
			display: flex;
		}

		&:hover {
			svg path {
				fill: ${colors.bluegray}
			}
		}
	}

	@keyframes appearMenu {
		0% {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	.menuButtonWrapper {
		.menu-active {
			color: ${props => props.hoverColor || colors.infiosGray};

			&:after {
				background-color: ${(props) => props.hoverColor ? props.hoverColor : (!(props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
			}
		}
	}

	.stardard-link {
		&:hover {
			color: ${props => props.hoverColor || colors.infiosGray};
		}
	}

	.first-level, .second-level, .third-level {
		a:hover, .menu-active, button:hover {
			background: ${props => props.hoverColor || colors.limeGreen} !important;
		}
	}

	${InfiosLink},
	.tertiary {
		&:after {
			background-color: ${(props) => props.hoverColor ? props.hoverColor : (!(props.blackLetter === "whiteBlack" || props.blackLetter === "transparentBlack") ? colors.infiosGray : colors.white)};
		}
	}
`;

export const InfiosHeaderMenuWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const InfiosHeaderMenuItems = styled.ul`
	${grid}
	width: 100vw;
	position: fixed;
	display: flex;
	justify-content: space-between;
	left: 0;
	top: ${(props) => props.height}px;
	background: ${colors.white};
	list-style: none;
	z-index: 1;
	overflow-y: scroll;
	height: 80%;

	${props => !props.isMobile && `
    width: calc(100% - 156px);
    max-width: 1548px;
    left: 50%;
    transform: translateX(-50%);
    padding-left: 28px;
    padding-right: 41px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    height: 536px;
    max-height: 80%;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
	li {
		display: flex;
		flex-direction: column;
		white-space: break-spaces;
	}

	${InfiosButton},
	${InfiosLink} {
		&:not(:hover) {
			color: ${colors.bluegray};
		}
	}

	${InfiosLearnMore} {
		${InfiosButton},
		${InfiosLink} {
			&:not(:hover) {
				color: ${colors.white};
			}
		}

		${props => !props.isMobile && `
      position: absolute;
      width: calc(33vw - 92px);
      max-width: 335px;
    `}
	}

	.close {
		display: flex;
		position: absolute;
		top: 40px;
		right: 0;
		z-index: 1;
		background-color: ${colors.white};

		${props => !props.isMobile && `
      display: none;
    `}

		svg {
			path {
				fill: ${colors.infiosGray};
			}
		}

		&:not(:hover) svg {
			transform: ${(props) =>
				props.animatedVertically ? animations.vertical : animations.cta};
		}

		@media ${devices.mobileAndTablet} {
			${grid}
			position: fixed;
			top: 95px;
			left: 0;
			right: auto;
			width: 100vw;
			color: ${colors.bluegray};
			border-top: 1px solid ${colors.gray2};
			border-bottom: 1px solid ${colors.gray2};
			padding: 16px 20px !important;
			cursor: pointer;
		}
	}

	> .container {
		position: relative;
		flex-direction: row;
		align-items: flex-start;
		padding: 96px 0;
		height: 100%;

		${props => !props.isMobile && `
			padding: 57px 0px 34px;
		`}

		.title {
			padding: 0 0 30px 17px;
			max-width: 420px;
			width: calc(33vw - 9.3%);
			color: ${colors.bluegray};
			font-family: ${fonts.AeonikPro};
			font-size: 29px;
			font-style: normal;
			font-weight: 500;
			line-height: 27px;
			letter-spacing: -0.587px;

			@media ${devices.mobileAndTablet} {
				width: 100%;
				max-width: 100%;
				font-size: 29px;
				font-style: normal;
				font-weight: 500;
				line-height: 27px;
				letter-spacing: -0.587px;
				padding-left: 20px;
			}
		}

		.first-level {
			max-width: 420px;
			width: calc(33vw - 9.3%);

			@media ${devices.mobileAndTablet} {
				max-width: unset;
				width: 100%;
			}

			animation-name: flyinLeft;
			animation-duration: 0.2s;
			animation-timing-function: ease-out;
			animation-fill-mode: backwards;

			${animateItens}
			&:last-child {
				.p-regular {
					border-bottom: none;
				}
			}

			> li {
				${InfiosButton},
				${InfiosLink} {
					display: flex;
					justify-content: space-between;
					padding: 14px 20px;
					border-bottom: 1px solid #3241553e;
					border-radius: 0;
					width: 100%;
					max-height: 100%;

					${props => !props.isMobile && `
						padding: 14.5px 0 14.5px 17px;
					`}

					&:not(:hover) {
						svg {
							path {
								fill: ${colors.infiosGray};
							}
						}
					}
				}

				.menu-active {
					background: ${colors.limeGreen};
				}

				.second-level,
				.third-level {
					display: flex;
					position: absolute;
					max-width: 420px;
					top: 0;
					left: 0;
					transform: translateX(calc(100% + 32px));
					z-index: 1;

					> li {
						width: 100%;
						${props => !props.isMobile && `
							> a {
								pointer-events: none;
							}
						`}

						a > .title {
							${props => !props.isMobile && `
								padding: 0;
								opacity: 0;
								pointer-events: none;
								height: ${(props) => props.firstTitleHeight}px;
								min-height: ${(props) => props.firstTitleHeight}px;
							`}
						}

						.second-level-item {
							animation-name: flyinLeft;
							animation-duration: 0.2s;
							animation-timing-function: ease-out;
							animation-fill-mode: backwards;

							&:last-child {
								.p-regular {
									border-bottom: none;
								}
							}

							${animateItens}
							&:nth-child(2) {
								@media ${devices.tabletLarge} {
									border-top: unset;
								}
							}
						}
					}

					@media ${devices.mobileAndTablet} {
						position: fixed;
						padding: 46px 24px;
						height: calc(100vh - 130px);
						width: 100%;
						background: ${colors.white};
						width: 100%;
						max-width: 100%;
						transform: translate(0);
						left: 0;
						top: 130px;
						bottom: 0;
						overflow: auto;

						&.static {
							overflow: hidden;
						}
					}

					@media ${devices.tablets} {
						padding: 46px;
					}
				}

				.second-level {

					${props => !props.isMobile && `
						width: calc(33vw - 9.3%);
					`}

					@media ${devices.mobileAndTablet} {
						padding: 46px 0;
					}
				}

				.third-level {
					top: 0;


					ul {
						li {
							animation-name: flyinLeft;
							animation-duration: 0.2s;
							animation-timing-function: ease-out;
							animation-fill-mode: both;

							&:last-child {
								.p-regular {
									border-bottom: none;
								}
							}

							${animateItens}
							&:nth-child(1) {
								@media ${devices.tabletLarge} {
									border-top: unset;
								}
							}
						}
					}

					${props => !props.isMobile && `
						width: 100%;
					`}

					@media ${devices.tabletLarge} {
						left: 0;
					}

					@media ${devices.mobileAndTablet} {
						padding: 46px 0;
					}
				}
			}

			@media ${devices.mobileAndTablet} {
				max-width: 100%;
			}
		}
	}

	ul {
		list-style: none;
	}

	&.mobile {
		top: 69px;
		height: calc(100vh - 69px);
		overflow: auto;
		padding: 0;

		&.static {
			overflow: hidden;
		}

		&:not(.active) {
			${props => props.isMobile && `
				display: none;
			`}
		}
	}

	@keyframes flyinLeft {
		0% {
			transform: translateX(-20px);
			opacity: 0;
		}

		to {
			transform: translateX(0);
			opacity: 1;
		}
	}


`;
